import { getPaintProperty } from "../../utils/transmission-insights/filter-expression-utils";

export type ISOFilterOptions =
    | "PJM"
    | "MISO"
    | "SPP"
    | "NYISO"
    | "ISONE"
    | "ERCOT"
    | null;

export const ISOFilters: ISOFilterOptions[] = [
    "PJM",
    "MISO",
    "SPP",
    "NYISO",
    "ISONE",
    "ERCOT",
];

export const QI_LAYER_IDS = {
    QUEUE_ISO_LAYER_ID: "queue-iso-layer",
    BUS_LOCATION_LAYER_ID: "bus-location-layer",
    TRANSMISSION_LINES_LAYER_ID: "transmission-lines-layer",
    GENERATOR_OPERATING_LAYER_ID: "generator-operating-layer",
    GENERATOR_PLANNED_LAYER_ID: "generator-planned-layer",
    GENERATOR_RETIRED_LAYER_ID: "generator-retired-layer",
};

export const QI_BUS_LAYER_SETTINGS = {
    type: "symbol",
    source: "bus-location-source",
    layout: {
        "icon-image": "custom-triangle",
        "icon-size": [
            "interpolate",
            ["linear"],
            ["zoom"],
            0,
            0,
            3,
            0.0,
            5,
            0.55,
            10,
            0.7,
            22,
            1,
        ],
        "icon-allow-overlap": false,
        "icon-ignore-placement": true,
        "icon-rotation-alignment": "map",
        "icon-pitch-alignment": "map",
    },
    paint: {
        "icon-color": getPaintProperty("bus")!,
        "icon-opacity": 1,
    },
    filter: [
        ">=",
        ["zoom"],
        [
            "case",
            [">=", ["get", "Voltage"], 200],
            3,
            [
                "all",
                [">=", ["get", "Voltage"], 100],
                ["<", ["get", "Voltage"], 200],
            ],
            5,
            6,
        ],
    ],
};

export const QI_LINE_LAYER_SETTINGS = {
    type: "line",
    source: "transmission-lines-source",
    maxzoom: 22,
    layout: {
        "line-join": "round",
        "line-cap": "round",
        visibility: "visible",
        "line-sort-key": ["get", "VOLTAGE"],
    },
    paint: {
        "line-color": getPaintProperty("transmission-lines")!,
        "line-width": 2,
    },
    filter: [
        ">=",
        ["zoom"],
        [
            "case",
            [">=", ["get", "VOLTAGE"], 500],
            3,
            [
                "all",
                [">=", ["get", "VOLTAGE"], 200],
                ["<", ["get", "VOLTAGE"], 500],
            ],
            4,
            [
                "all",
                [">=", ["get", "VOLTAGE"], 100],
                ["<", ["get", "VOLTAGE"], 200],
            ],
            5,
            7,
        ],
    ],
};

export const QI_OPERATING_LAYER_SETTINGS = {
    type: "circle",
    source: "generator-operating-source",
    paint: {
        "circle-color": "#1ABA0E",
        "circle-radius": [
            "interpolate",
            ["linear"],
            ["zoom"],
            0,
            0,
            5,
            2,
            22,
            10,
        ],
        "circle-opacity": 0.8,
        "circle-stroke-width": [
            "interpolate",
            ["linear"],
            ["zoom"],
            0,
            0,
            5,
            0.1,
            22,
            2,
        ],
        "circle-stroke-color": "#ffffff",
    },
};
